import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=d179d382&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=d179d382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d179d382",
  null
  
)

export default component.exports